__turbopack_context__.v({
  "container": "elias-signoff-module__qrLqiG__container",
  "content": "elias-signoff-module__qrLqiG__content",
  "glow": "elias-signoff-module__qrLqiG__glow",
  "glowContainer": "elias-signoff-module__qrLqiG__glowContainer",
  "signoff": "elias-signoff-module__qrLqiG__signoff",
});
